function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id = 0;
function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}
import { h } from 'preact';
import PQueue from 'p-queue';
import { getSafeFileId } from '@uppy/utils/lib/generateFileID';
import AuthView from "./AuthView.js";
import Header from "./Header.js";
import Browser from "../Browser.js";
import CloseWrapper from "../CloseWrapper.js";
import View from "../View.js";

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
var packageJson = {
  "version": "3.13.0"
};
function formatBreadcrumbs(breadcrumbs) {
  return breadcrumbs.slice(1).map(function (directory) {
    return directory.name;
  }).join('/');
}
function prependPath(path, component) {
  if (!path) return component;
  return "".concat(path, "/").concat(component);
}
export function defaultPickerIcon() {
  return h("svg", {
    "aria-hidden": "true",
    focusable: "false",
    width: "30",
    height: "30",
    viewBox: "0 0 30 30"
  }, h("path", {
    d: "M15 30c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15zm4.258-12.676v6.846h-8.426v-6.846H5.204l9.82-12.364 9.82 12.364H19.26z"
  }));
}
var defaultOptions = {
  viewType: 'list',
  showTitles: true,
  showFilter: true,
  showBreadcrumbs: true,
  loadAllFiles: false,
  virtualList: false
};
var _abortController = /*#__PURE__*/_classPrivateFieldLooseKey("abortController");
var _withAbort = /*#__PURE__*/_classPrivateFieldLooseKey("withAbort");
var _list = /*#__PURE__*/_classPrivateFieldLooseKey("list");
var _listFilesAndFolders = /*#__PURE__*/_classPrivateFieldLooseKey("listFilesAndFolders");
var _recursivelyListAllFiles = /*#__PURE__*/_classPrivateFieldLooseKey("recursivelyListAllFiles");
/**
 * Class to easily generate generic views for Provider plugins
 */
var ProviderView = /*#__PURE__*/function (_View) {
  _inherits(ProviderView, _View);
  function ProviderView(plugin, opts) {
    var _this2;
    _classCallCheck(this, ProviderView);
    _this2 = _callSuper(this, ProviderView, [plugin, _objectSpread(_objectSpread({}, defaultOptions), opts)]);

    // Logic
    Object.defineProperty(_assertThisInitialized(_this2), _recursivelyListAllFiles, {
      value: _recursivelyListAllFiles2
    });
    Object.defineProperty(_assertThisInitialized(_this2), _listFilesAndFolders, {
      value: _listFilesAndFolders2
    });
    Object.defineProperty(_assertThisInitialized(_this2), _list, {
      value: _list2
    });
    Object.defineProperty(_assertThisInitialized(_this2), _withAbort, {
      value: _withAbort2
    });
    Object.defineProperty(_assertThisInitialized(_this2), _abortController, {
      writable: true,
      value: void 0
    });
    _this2.filterQuery = _this2.filterQuery.bind(_assertThisInitialized(_this2));
    _this2.clearFilter = _this2.clearFilter.bind(_assertThisInitialized(_this2));
    _this2.getFolder = _this2.getFolder.bind(_assertThisInitialized(_this2));
    _this2.getNextFolder = _this2.getNextFolder.bind(_assertThisInitialized(_this2));
    _this2.logout = _this2.logout.bind(_assertThisInitialized(_this2));
    _this2.handleAuth = _this2.handleAuth.bind(_assertThisInitialized(_this2));
    _this2.handleScroll = _this2.handleScroll.bind(_assertThisInitialized(_this2));
    _this2.donePicking = _this2.donePicking.bind(_assertThisInitialized(_this2));

    // Visual
    _this2.render = _this2.render.bind(_assertThisInitialized(_this2));

    // Set default state for the plugin
    _this2.plugin.setPluginState({
      authenticated: undefined,
      // we don't know yet
      files: [],
      folders: [],
      breadcrumbs: [],
      filterInput: '',
      isSearchVisible: false,
      currentSelection: []
    });
    _this2.registerRequestClient();
    return _this2;
  }

  // eslint-disable-next-line class-methods-use-this
  _createClass(ProviderView, [{
    key: "tearDown",
    value: function tearDown() {
      // Nothing.
    }
    /**
     * Select a folder based on its id: fetches the folder and then updates state with its contents
     * TODO rename to something better like selectFolder or navigateToFolder (breaking change?)
     *
     */
  }, {
    key: "getFolder",
    value: (function () {
      var _getFolder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(requestPath, name) {
        var _this3 = this;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.setLoading(true);
              _context2.prev = 1;
              _context2.next = 4;
              return _classPrivateFieldLooseBase(this, _withAbort)[_withAbort]( /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(signal) {
                  var _this3$plugin$getPlug, breadcrumbs, index, files, folders, _yield$_classPrivateF, newFiles, newFolders;
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        _this3.lastCheckbox = undefined;
                        _this3$plugin$getPlug = _this3.plugin.getPluginState(), breadcrumbs = _this3$plugin$getPlug.breadcrumbs;
                        index = breadcrumbs.findIndex(function (dir) {
                          return requestPath === dir.requestPath;
                        });
                        if (index !== -1) {
                          // means we navigated back to a known directory (already in the stack), so cut the stack off there
                          breadcrumbs = breadcrumbs.slice(0, index + 1);
                        } else {
                          // we have navigated into a new (unknown) folder, add it to the stack
                          breadcrumbs = [].concat(_toConsumableArray(breadcrumbs), [{
                            requestPath: requestPath,
                            name: name
                          }]);
                        }
                        _this3.nextPagePath = requestPath;
                        files = [];
                        folders = [];
                      case 7:
                        _context.next = 9;
                        return _classPrivateFieldLooseBase(_this3, _listFilesAndFolders)[_listFilesAndFolders]({
                          breadcrumbs: breadcrumbs,
                          signal: signal
                        });
                      case 9:
                        _yield$_classPrivateF = _context.sent;
                        newFiles = _yield$_classPrivateF.files;
                        newFolders = _yield$_classPrivateF.folders;
                        files = files.concat(newFiles);
                        folders = folders.concat(newFolders);
                        _this3.setLoading(_this3.plugin.uppy.i18n('loadedXFiles', {
                          numFiles: files.length + folders.length
                        }));
                      case 15:
                        if (_this3.opts.loadAllFiles && _this3.nextPagePath) {
                          _context.next = 7;
                          break;
                        }
                      case 16:
                        _this3.plugin.setPluginState({
                          folders: folders,
                          files: files,
                          breadcrumbs: breadcrumbs,
                          filterInput: ''
                        });
                      case 17:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x3) {
                  return _ref4.apply(this, arguments);
                };
              }());
            case 4:
              _context2.next = 12;
              break;
            case 6:
              _context2.prev = 6;
              _context2.t0 = _context2["catch"](1);
              if (!((_context2.t0 == null ? void 0 : _context2.t0.name) === 'UserFacingApiError')) {
                _context2.next = 11;
                break;
              }
              this.plugin.uppy.info({
                message: this.plugin.uppy.i18n(_context2.t0.message)
              }, 'warning', 5000);
              return _context2.abrupt("return");
            case 11:
              this.handleError(_context2.t0);
            case 12:
              _context2.prev = 12;
              this.setLoading(false);
              return _context2.finish(12);
            case 15:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[1, 6, 12, 15]]);
      }));
      function getFolder(_x, _x2) {
        return _getFolder.apply(this, arguments);
      }
      return getFolder;
    }()
    /**
     * Fetches new folder
     */
    )
  }, {
    key: "getNextFolder",
    value: function getNextFolder(folder) {
      this.getFolder(folder.requestPath, folder.name);
      this.lastCheckbox = undefined;
    }

    /**
     * Removes session token on client side.
     */
  }, {
    key: "logout",
    value: (function () {
      var _logout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this4 = this;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return _classPrivateFieldLooseBase(this, _withAbort)[_withAbort]( /*#__PURE__*/function () {
                var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(signal) {
                  var res, message, newState;
                  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.next = 2;
                        return _this4.provider.logout({
                          signal: signal
                        });
                      case 2:
                        res = _context3.sent;
                        // res.ok is from the JSON body, not to be confused with Response.ok
                        if (res.ok) {
                          if (!res.revoked) {
                            message = _this4.plugin.uppy.i18n('companionUnauthorizeHint', {
                              provider: _this4.plugin.title,
                              url: res.manual_revoke_url
                            });
                            _this4.plugin.uppy.info(message, 'info', 7000);
                          }
                          newState = {
                            authenticated: false,
                            files: [],
                            folders: [],
                            breadcrumbs: [],
                            filterInput: ''
                          };
                          _this4.plugin.setPluginState(newState);
                        }
                      case 4:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee3);
                }));
                return function (_x4) {
                  return _ref5.apply(this, arguments);
                };
              }());
            case 3:
              _context4.next = 8;
              break;
            case 5:
              _context4.prev = 5;
              _context4.t0 = _context4["catch"](0);
              this.handleError(_context4.t0);
            case 8:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[0, 5]]);
      }));
      function logout() {
        return _logout.apply(this, arguments);
      }
      return logout;
    }())
  }, {
    key: "filterQuery",
    value: function filterQuery(input) {
      this.plugin.setPluginState({
        filterInput: input
      });
    }
  }, {
    key: "clearFilter",
    value: function clearFilter() {
      this.plugin.setPluginState({
        filterInput: ''
      });
    }
  }, {
    key: "handleAuth",
    value: function () {
      var _handleAuth = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(authFormData) {
        var _this5 = this;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              _context6.next = 3;
              return _classPrivateFieldLooseBase(this, _withAbort)[_withAbort]( /*#__PURE__*/function () {
                var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(signal) {
                  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                    while (1) switch (_context5.prev = _context5.next) {
                      case 0:
                        _this5.setLoading(true);
                        _context5.next = 3;
                        return _this5.provider.login({
                          authFormData: authFormData,
                          signal: signal
                        });
                      case 3:
                        _this5.plugin.setPluginState({
                          authenticated: true
                        });
                        _this5.preFirstRender();
                      case 5:
                      case "end":
                        return _context5.stop();
                    }
                  }, _callee5);
                }));
                return function (_x6) {
                  return _ref6.apply(this, arguments);
                };
              }());
            case 3:
              _context6.next = 11;
              break;
            case 5:
              _context6.prev = 5;
              _context6.t0 = _context6["catch"](0);
              if (!(_context6.t0.name === 'UserFacingApiError')) {
                _context6.next = 10;
                break;
              }
              this.plugin.uppy.info({
                message: this.plugin.uppy.i18n(_context6.t0.message)
              }, 'warning', 5000);
              return _context6.abrupt("return");
            case 10:
              this.plugin.uppy.log("login failed: ".concat(_context6.t0.message));
            case 11:
              _context6.prev = 11;
              this.setLoading(false);
              return _context6.finish(11);
            case 14:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[0, 5, 11, 14]]);
      }));
      function handleAuth(_x5) {
        return _handleAuth.apply(this, arguments);
      }
      return handleAuth;
    }()
  }, {
    key: "handleScroll",
    value: function () {
      var _handleScroll = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(event) {
        var _this6 = this;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (!(this.shouldHandleScroll(event) && this.nextPagePath)) {
                _context8.next = 13;
                break;
              }
              this.isHandlingScroll = true;
              _context8.prev = 2;
              _context8.next = 5;
              return _classPrivateFieldLooseBase(this, _withAbort)[_withAbort]( /*#__PURE__*/function () {
                var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(signal) {
                  var _this6$plugin$getPlug, files, folders, breadcrumbs, _yield$_classPrivateF2, newFiles, newFolders, combinedFiles, combinedFolders;
                  return _regeneratorRuntime().wrap(function _callee7$(_context7) {
                    while (1) switch (_context7.prev = _context7.next) {
                      case 0:
                        _this6$plugin$getPlug = _this6.plugin.getPluginState(), files = _this6$plugin$getPlug.files, folders = _this6$plugin$getPlug.folders, breadcrumbs = _this6$plugin$getPlug.breadcrumbs;
                        _context7.next = 3;
                        return _classPrivateFieldLooseBase(_this6, _listFilesAndFolders)[_listFilesAndFolders]({
                          breadcrumbs: breadcrumbs,
                          signal: signal
                        });
                      case 3:
                        _yield$_classPrivateF2 = _context7.sent;
                        newFiles = _yield$_classPrivateF2.files;
                        newFolders = _yield$_classPrivateF2.folders;
                        combinedFiles = files.concat(newFiles);
                        combinedFolders = folders.concat(newFolders);
                        _this6.plugin.setPluginState({
                          folders: combinedFolders,
                          files: combinedFiles
                        });
                      case 9:
                      case "end":
                        return _context7.stop();
                    }
                  }, _callee7);
                }));
                return function (_x8) {
                  return _ref7.apply(this, arguments);
                };
              }());
            case 5:
              _context8.next = 10;
              break;
            case 7:
              _context8.prev = 7;
              _context8.t0 = _context8["catch"](2);
              this.handleError(_context8.t0);
            case 10:
              _context8.prev = 10;
              this.isHandlingScroll = false;
              return _context8.finish(10);
            case 13:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this, [[2, 7, 10, 13]]);
      }));
      function handleScroll(_x7) {
        return _handleScroll.apply(this, arguments);
      }
      return handleScroll;
    }()
  }, {
    key: "donePicking",
    value: function () {
      var _donePicking = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var _this7 = this;
        return _regeneratorRuntime().wrap(function _callee10$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              this.setLoading(true);
              _context11.prev = 1;
              _context11.next = 4;
              return _classPrivateFieldLooseBase(this, _withAbort)[_withAbort]( /*#__PURE__*/function () {
                var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(signal) {
                  var _this7$plugin$getPlug, currentSelection, messages, newFiles, _iterator, _step, _loop;
                  return _regeneratorRuntime().wrap(function _callee9$(_context10) {
                    while (1) switch (_context10.prev = _context10.next) {
                      case 0:
                        _this7$plugin$getPlug = _this7.plugin.getPluginState(), currentSelection = _this7$plugin$getPlug.currentSelection;
                        messages = [];
                        newFiles = [];
                        _iterator = _createForOfIteratorHelper(currentSelection);
                        _context10.prev = 4;
                        _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop() {
                          var selectedItem, requestPath, withRelDirPath, isEmpty, numNewFiles, queue, onFiles, message;
                          return _regeneratorRuntime().wrap(function _loop$(_context9) {
                            while (1) switch (_context9.prev = _context9.next) {
                              case 0:
                                selectedItem = _step.value;
                                requestPath = selectedItem.requestPath;
                                withRelDirPath = function withRelDirPath(newItem) {
                                  return _objectSpread(_objectSpread({}, newItem), {}, {
                                    // calculate the file's path relative to the user's selected item's path
                                    // see https://github.com/transloadit/uppy/pull/4537#issuecomment-1614236655
                                    relDirPath: newItem.absDirPath.replace(selectedItem.absDirPath, '').replace(/^\//, '')
                                  });
                                };
                                if (!selectedItem.isFolder) {
                                  _context9.next = 16;
                                  break;
                                }
                                isEmpty = true;
                                numNewFiles = 0;
                                queue = new PQueue({
                                  concurrency: 6
                                });
                                onFiles = function onFiles(files) {
                                  var _iterator2 = _createForOfIteratorHelper(files),
                                    _step2;
                                  try {
                                    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                                      var newFile = _step2.value;
                                      var tagFile = _this7.getTagFile(newFile);
                                      var _id = getSafeFileId(tagFile, _this7.plugin.uppy.getID());
                                      // If the same folder is added again, we don't want to send
                                      // X amount of duplicate file notifications, we want to say
                                      // the folder was already added. This checks if all files are duplicate,
                                      // if that's the case, we don't add the files.
                                      if (!_this7.plugin.uppy.checkIfFileAlreadyExists(_id)) {
                                        newFiles.push(withRelDirPath(newFile));
                                        numNewFiles++;
                                        _this7.setLoading(_this7.plugin.uppy.i18n('addedNumFiles', {
                                          numFiles: numNewFiles
                                        }));
                                      }
                                      isEmpty = false;
                                    }
                                  } catch (err) {
                                    _iterator2.e(err);
                                  } finally {
                                    _iterator2.f();
                                  }
                                };
                                _context9.next = 10;
                                return _classPrivateFieldLooseBase(_this7, _recursivelyListAllFiles)[_recursivelyListAllFiles]({
                                  requestPath: requestPath,
                                  absDirPath: prependPath(selectedItem.absDirPath, selectedItem.name),
                                  relDirPath: selectedItem.name,
                                  queue: queue,
                                  onFiles: onFiles,
                                  signal: signal
                                });
                              case 10:
                                _context9.next = 12;
                                return queue.onIdle();
                              case 12:
                                if (isEmpty) {
                                  message = _this7.plugin.uppy.i18n('emptyFolderAdded');
                                } else if (numNewFiles === 0) {
                                  message = _this7.plugin.uppy.i18n('folderAlreadyAdded', {
                                    folder: selectedItem.name
                                  });
                                } else {
                                  // TODO we don't really know at this point whether any files were actually added
                                  // (only later after addFiles has been called) so we should probably rewrite this.
                                  // Example: If all files fail to add due to restriction error, it will still say "Added 100 files from folder"
                                  message = _this7.plugin.uppy.i18n('folderAdded', {
                                    smart_count: numNewFiles,
                                    folder: selectedItem.name
                                  });
                                }
                                messages.push(message);
                                _context9.next = 17;
                                break;
                              case 16:
                                newFiles.push(withRelDirPath(selectedItem));
                              case 17:
                              case "end":
                                return _context9.stop();
                            }
                          }, _loop);
                        });
                        _iterator.s();
                      case 7:
                        if ((_step = _iterator.n()).done) {
                          _context10.next = 11;
                          break;
                        }
                        return _context10.delegateYield(_loop(), "t0", 9);
                      case 9:
                        _context10.next = 7;
                        break;
                      case 11:
                        _context10.next = 16;
                        break;
                      case 13:
                        _context10.prev = 13;
                        _context10.t1 = _context10["catch"](4);
                        _iterator.e(_context10.t1);
                      case 16:
                        _context10.prev = 16;
                        _iterator.f();
                        return _context10.finish(16);
                      case 19:
                        // Note: this.plugin.uppy.addFiles must be only run once we are done fetching all files,
                        // because it will cause the loading screen to disappear,
                        // and that will allow the user to start the upload, so we need to make sure we have
                        // finished all async operations before we add any file
                        // see https://github.com/transloadit/uppy/pull/4384
                        _this7.plugin.uppy.log('Adding files from a remote provider');
                        _this7.plugin.uppy.addFiles(
                        // @ts-expect-error `addFiles` expects `body` to be `File` or `Blob`,
                        // but as the todo comment in `View.ts` indicates, we strangly pass `CompanionFile` as `body`.
                        // For now it's better to ignore than to have a potential breaking change.
                        newFiles.map(function (file) {
                          return _this7.getTagFile(file, _this7.requestClientId);
                        }));
                        _this7.plugin.setPluginState({
                          filterInput: ''
                        });
                        messages.forEach(function (message) {
                          return _this7.plugin.uppy.info(message);
                        });
                        _this7.clearSelection();
                      case 24:
                      case "end":
                        return _context10.stop();
                    }
                  }, _callee9, null, [[4, 13, 16, 19]]);
                }));
                return function (_x9) {
                  return _ref8.apply(this, arguments);
                };
              }());
            case 4:
              _context11.next = 9;
              break;
            case 6:
              _context11.prev = 6;
              _context11.t0 = _context11["catch"](1);
              this.handleError(_context11.t0);
            case 9:
              _context11.prev = 9;
              this.setLoading(false);
              return _context11.finish(9);
            case 12:
            case "end":
              return _context11.stop();
          }
        }, _callee10, this, [[1, 6, 9, 12]]);
      }));
      function donePicking() {
        return _donePicking.apply(this, arguments);
      }
      return donePicking;
    }()
  }, {
    key: "render",
    value: function render(state, viewOptions) {
      var _this = this;
      if (viewOptions === void 0) {
        viewOptions = {};
      }
      var _this$plugin$getPlugi = this.plugin.getPluginState(),
        authenticated = _this$plugin$getPlugi.authenticated,
        didFirstRender = _this$plugin$getPlugi.didFirstRender;
      var i18n = this.plugin.uppy.i18n;
      if (!didFirstRender) {
        this.preFirstRender();
      }
      var targetViewOptions = _objectSpread(_objectSpread({}, this.opts), viewOptions);
      var _this$plugin$getPlugi2 = this.plugin.getPluginState(),
        files = _this$plugin$getPlugi2.files,
        folders = _this$plugin$getPlugi2.folders,
        filterInput = _this$plugin$getPlugi2.filterInput,
        loading = _this$plugin$getPlugi2.loading,
        currentSelection = _this$plugin$getPlugi2.currentSelection;
      var isChecked = this.isChecked,
        recordShiftKeyPress = this.recordShiftKeyPress,
        filterItems = this.filterItems;
      var hasInput = filterInput !== '';
      var pluginIcon = this.plugin.icon || defaultPickerIcon;
      var headerProps = {
        showBreadcrumbs: targetViewOptions.showBreadcrumbs,
        getFolder: this.getFolder,
        breadcrumbs: this.plugin.getPluginState().breadcrumbs,
        pluginIcon: pluginIcon,
        title: this.plugin.title,
        logout: this.logout,
        username: this.username,
        i18n: i18n
      };
      var browserProps = {
        isChecked: isChecked,
        toggleCheckbox: this.toggleCheckbox.bind(this),
        recordShiftKeyPress: recordShiftKeyPress,
        currentSelection: currentSelection,
        files: hasInput ? filterItems(files) : files,
        folders: hasInput ? filterItems(folders) : folders,
        getNextFolder: this.getNextFolder,
        getFolder: this.getFolder,
        loadAllFiles: this.opts.loadAllFiles,
        virtualList: this.opts.virtualList,
        // For SearchFilterInput component
        showSearchFilter: targetViewOptions.showFilter,
        search: this.filterQuery,
        clearSearch: this.clearFilter,
        searchTerm: filterInput,
        searchOnInput: true,
        searchInputLabel: i18n('filter'),
        clearSearchLabel: i18n('resetFilter'),
        noResultsLabel: i18n('noFilesFound'),
        logout: this.logout,
        handleScroll: this.handleScroll,
        done: this.donePicking,
        cancel: this.cancelPicking,
        // eslint-disable-next-line react/jsx-props-no-spreading
        headerComponent: h(Header, headerProps),
        title: this.plugin.title,
        viewType: targetViewOptions.viewType,
        showTitles: targetViewOptions.showTitles,
        showBreadcrumbs: targetViewOptions.showBreadcrumbs,
        pluginIcon: pluginIcon,
        i18n: this.plugin.uppy.i18n,
        uppyFiles: this.plugin.uppy.getFiles(),
        validateRestrictions: function validateRestrictions() {
          var _this$plugin$uppy;
          return (_this$plugin$uppy = _this.plugin.uppy).validateRestrictions.apply(_this$plugin$uppy, arguments);
        },
        isLoading: loading
      };
      if (authenticated === false) {
        return h(CloseWrapper, {
          onUnmount: this.clearSelection
        }, h(AuthView, {
          pluginName: this.plugin.title,
          pluginIcon: pluginIcon,
          handleAuth: this.handleAuth,
          i18n: this.plugin.uppy.i18nArray,
          renderForm: this.opts.renderAuthForm,
          loading: loading
        }));
      }
      return h(CloseWrapper, {
        onUnmount: this.clearSelection
      }, h(Browser, browserProps));
    }
  }]);
  return ProviderView;
}(View);
export { ProviderView as default };
function _withAbort2(_x10) {
  return _withAbort3.apply(this, arguments);
}
function _withAbort3() {
  _withAbort3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(op) {
    var _this8 = this;
    var _classPrivateFieldLoo, abortController, cancelRequest;
    return _regeneratorRuntime().wrap(function _callee11$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          // prevent multiple requests in parallel from causing race conditions
          (_classPrivateFieldLoo = _classPrivateFieldLooseBase(this, _abortController)[_abortController]) == null || _classPrivateFieldLoo.abort();
          abortController = new AbortController();
          _classPrivateFieldLooseBase(this, _abortController)[_abortController] = abortController;
          cancelRequest = function cancelRequest() {
            abortController.abort();
            _this8.clearSelection();
          };
          _context12.prev = 4;
          // @ts-expect-error this should be typed in @uppy/dashboard.
          // Even then I don't think we can make this work without adding dashboard
          // as a dependency to provider-views.
          this.plugin.uppy.on('dashboard:close-panel', cancelRequest);
          this.plugin.uppy.on('cancel-all', cancelRequest);
          _context12.next = 9;
          return op(abortController.signal);
        case 9:
          _context12.prev = 9;
          // @ts-expect-error this should be typed in @uppy/dashboard.
          // Even then I don't think we can make this work without adding dashboard
          // as a dependency to provider-views.
          this.plugin.uppy.off('dashboard:close-panel', cancelRequest);
          this.plugin.uppy.off('cancel-all', cancelRequest);
          _classPrivateFieldLooseBase(this, _abortController)[_abortController] = undefined;
          return _context12.finish(9);
        case 14:
        case "end":
          return _context12.stop();
      }
    }, _callee11, this, [[4,, 9, 14]]);
  }));
  return _withAbort3.apply(this, arguments);
}
function _list2(_x11) {
  return _list3.apply(this, arguments);
}
function _list3() {
  _list3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(_ref) {
    var requestPath, absDirPath, signal, _yield$this$provider$, username, nextPagePath, items;
    return _regeneratorRuntime().wrap(function _callee12$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          requestPath = _ref.requestPath, absDirPath = _ref.absDirPath, signal = _ref.signal;
          _context13.next = 3;
          return this.provider.list(requestPath, {
            signal: signal
          });
        case 3:
          _yield$this$provider$ = _context13.sent;
          username = _yield$this$provider$.username;
          nextPagePath = _yield$this$provider$.nextPagePath;
          items = _yield$this$provider$.items;
          this.username = username || this.username;
          return _context13.abrupt("return", {
            items: items.map(function (item) {
              return _objectSpread(_objectSpread({}, item), {}, {
                absDirPath: absDirPath
              });
            }),
            nextPagePath: nextPagePath
          });
        case 9:
        case "end":
          return _context13.stop();
      }
    }, _callee12, this);
  }));
  return _list3.apply(this, arguments);
}
function _listFilesAndFolders2(_x12) {
  return _listFilesAndFolders3.apply(this, arguments);
}
function _listFilesAndFolders3() {
  _listFilesAndFolders3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(_ref2) {
    var breadcrumbs, signal, absDirPath, _yield$_classPrivateF3, items, nextPagePath, files, folders;
    return _regeneratorRuntime().wrap(function _callee13$(_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          breadcrumbs = _ref2.breadcrumbs, signal = _ref2.signal;
          absDirPath = formatBreadcrumbs(breadcrumbs);
          _context14.next = 4;
          return _classPrivateFieldLooseBase(this, _list)[_list]({
            requestPath: this.nextPagePath,
            absDirPath: absDirPath,
            signal: signal
          });
        case 4:
          _yield$_classPrivateF3 = _context14.sent;
          items = _yield$_classPrivateF3.items;
          nextPagePath = _yield$_classPrivateF3.nextPagePath;
          this.nextPagePath = nextPagePath;
          files = [];
          folders = [];
          items.forEach(function (item) {
            if (item.isFolder) {
              folders.push(item);
            } else {
              files.push(item);
            }
          });
          return _context14.abrupt("return", {
            files: files,
            folders: folders
          });
        case 12:
        case "end":
          return _context14.stop();
      }
    }, _callee13, this);
  }));
  return _listFilesAndFolders3.apply(this, arguments);
}
function _recursivelyListAllFiles2(_x13) {
  return _recursivelyListAllFiles3.apply(this, arguments);
}
function _recursivelyListAllFiles3() {
  _recursivelyListAllFiles3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16(_ref3) {
    var _this9 = this;
    var requestPath, absDirPath, relDirPath, queue, onFiles, signal, curPath, res, files, folders, promises;
    return _regeneratorRuntime().wrap(function _callee16$(_context17) {
      while (1) switch (_context17.prev = _context17.next) {
        case 0:
          requestPath = _ref3.requestPath, absDirPath = _ref3.absDirPath, relDirPath = _ref3.relDirPath, queue = _ref3.queue, onFiles = _ref3.onFiles, signal = _ref3.signal;
          curPath = requestPath;
        case 2:
          if (!curPath) {
            _context17.next = 15;
            break;
          }
          _context17.next = 5;
          return _classPrivateFieldLooseBase(this, _list)[_list]({
            requestPath: curPath,
            absDirPath: absDirPath,
            signal: signal
          });
        case 5:
          res = _context17.sent;
          curPath = res.nextPagePath;
          files = res.items.filter(function (item) {
            return !item.isFolder;
          });
          folders = res.items.filter(function (item) {
            return item.isFolder;
          });
          onFiles(files);

          // recursively queue call to self for each folder
          promises = folders.map( /*#__PURE__*/function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15(folder) {
              return _regeneratorRuntime().wrap(function _callee15$(_context16) {
                while (1) switch (_context16.prev = _context16.next) {
                  case 0:
                    return _context16.abrupt("return", queue.add( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
                      return _regeneratorRuntime().wrap(function _callee14$(_context15) {
                        while (1) switch (_context15.prev = _context15.next) {
                          case 0:
                            return _context15.abrupt("return", _classPrivateFieldLooseBase(_this9, _recursivelyListAllFiles)[_recursivelyListAllFiles]({
                              requestPath: folder.requestPath,
                              absDirPath: prependPath(absDirPath, folder.name),
                              relDirPath: prependPath(relDirPath, folder.name),
                              queue: queue,
                              onFiles: onFiles,
                              signal: signal
                            }));
                          case 1:
                          case "end":
                            return _context15.stop();
                        }
                      }, _callee14);
                    }))));
                  case 1:
                  case "end":
                    return _context16.stop();
                }
              }, _callee15);
            }));
            return function (_x14) {
              return _ref9.apply(this, arguments);
            };
          }());
          _context17.next = 13;
          return Promise.all(promises);
        case 13:
          _context17.next = 2;
          break;
        case 15:
        case "end":
          return _context17.stop();
      }
    }, _callee16, this);
  }));
  return _recursivelyListAllFiles3.apply(this, arguments);
}
ProviderView.VERSION = packageJson.version;